import { DeepPartial, LocaleConfig } from '@empathybroker/ebx-gluon';
import * as messages from './messages';

export const MOBILE_LOCALE_CONFIG: DeepPartial<LocaleConfig> = {
  messages,
  currencies: {
    EUR: {
      hideDecimalsIfZero: true
    }
  }
};
